import Constant from '@/const';
import axios from 'axios';

const getRoa = async () => {
  try {
    const response = await axios.get(Constant.apiUrl.concat('/master/roa'));
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getRoa;
